module.exports = __webpack_public_path__ + "img/KM-360A_07.b7f079a7.jpg";